import { NgModule } from '@angular/core';
import { SafePipe } from './safe.pipe';



@NgModule({
    imports: [
    ],
    declarations: [
        SafePipe
    ],
    exports: [
        SafePipe
    ]
})

export class SharedModule { }


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/shared.module.ts